<template>
<div>
  <div class="ibox float-e-margins">
    <div class="row m-b-lg m-t-lg">
      <div class="col-md-2">
        <h3>Batch update</h3>
      </div>
    </div>
    <div class="tabs-container">
      <ul class="nav nav-tabs" role="tablist">
        <li class="active"><a class="nav-link" data-toggle="tab" href="#vid-tab">Plagin1</a></li>
        <li><a class="nav-link" data-toggle="tab" href="#video-search">Video Search</a></li>
        <li><a class="nav-link nav-item" data-toggle="tab" href="#static-content">Content</a></li>
        <li><a class="nav-link nav-item" data-toggle="tab" href="#plugins">Plugins</a></li>
        <li><a class="nav-link nav-item" data-toggle="tab" href="#tools">Tools</a></li>
      </ul>
      <div class="tab-content">
        <div class="tab-pane ibox-content active" role="tabpanel" id="Plagin">
        </div>
      </div>
    </div>
  </div>
</div>
</template>

<script>
export default {
  name: 'Plugins'
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/Pages/Manager/BatchUpdate/Plugins.vue